import React, { useRef } from 'react';
import { useInView } from 'framer-motion';
import CountUp from 'react-countup';
import { stats } from '../../data/mock';

const StatsBar = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <section ref={ref} className="relative py-8 overflow-hidden z-10">
      <div className="glass-card mx-4 lg:mx-16 rounded-xl px-6 lg:px-8 py-6">
        <div className="flex flex-wrap justify-between items-center gap-y-6 gap-x-4">
          {stats.map((stat, index) => (
            <React.Fragment key={index}>
              <div className="flex flex-col items-center text-center min-w-[120px] flex-1">
                <span className="font-display text-xl sm:text-2xl lg:text-3xl font-bold text-[#F0F4FF]">
                  {inView ? (
                    <CountUp
                      end={stat.value}
                      decimals={stat.decimals || 0}
                      duration={2.5}
                      suffix={stat.suffix}
                    />
                  ) : (
                    <span>0{stat.suffix}</span>
                  )}
                </span>
                <span className="font-mono text-[10px] sm:text-xs text-[#8892A4] mt-1">
                  {stat.label}
                </span>
              </div>
              {index < stats.length - 1 && (
                <div className="hidden lg:block w-px h-12 bg-gradient-to-b from-transparent via-[#00D4FF] to-transparent opacity-30" />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsBar;
